"use client";

import { Input } from "@heroui/input";
import { Select, SelectItem } from "@heroui/select";
import { Search } from "lucide-react";

interface GlossarySearchProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
}

export default function GlossarySearch({
  searchQuery,
  onSearchChange,
  selectedCategory,
  onCategoryChange,
}: GlossarySearchProps) {
  const categories = [
    "All Categories",
    "Genre",
    "Production",
    "Equipment",
    "Culture",
    "DJ Technique",
    "Music Theory",
    "Song Structure",
    "Sound Design",
    "Audio Effect",
    "Rhythm",
    "Event",
    "Rave Culture",
  ];

  return (
    <section className="mb-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="md:col-span-2">
          <Input
            type="text"
            placeholder="Search terms or definitions..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            startContent={<Search className="w-4 h-4 text-muted" />}
            classNames={{
              input: "text-ink text-sm focus:outline-none rounded-md",
              inputWrapper:
                "bg-surface/50 border border-line hover:border-line-strong data-[hover=true]:border-line-strong group-data-[focus=true]:border-line-strong group-data-[focused=true]:border-line-strong rounded-md",
              innerWrapper: "rounded-md",
              base: "rounded-md",
              mainWrapper: "rounded-md",
            }}
            size="lg"
          />
        </div>
        <Select
          label="Filter by Category"
          placeholder="All Categories"
          selectedKeys={selectedCategory ? [selectedCategory] : []}
          onSelectionChange={(keys) => {
            const selected = Array.from(keys)[0] as string;
            onCategoryChange(selected || "");
          }}
          classNames={{
            trigger:
              "bg-surface/50 border-line hover:border-line-strong data-[focus=true]:border-theme-light",
            value: "text-ink",
            label: "text-muted",
          }}
          size="sm"
        >
          {categories.map((category) => (
            <SelectItem key={category}>{category}</SelectItem>
          ))}
        </Select>
      </div>
    </section>
  );
}
